<template>
    <section v-if="OnDemandData.length > 0">
        <h1 class="main-title grid-container" v-if="OnDemandData[0].title != undefined && OnDemandData[0].title.rendered != undefined && OnDemandData[0].title.rendered != null && OnDemandData[0].title.rendered != ''">{{OnDemandData[0].title.rendered}}</h1>
        <div class="mobile-navigation ross-on-demand layer3"></div>
        <div class="media-list layer2">
            <div class="grid-container grid-100">
                <div class="video-item grid-100 grid-parent" style="">
                    <div class="video-header grid-100 grid-parent">
                        <div class="video">
                            <iframe :src="OnDemandData[0].video_url" v-if="OnDemandData[0].video_url != undefined && OnDemandData[0].video_url != null && OnDemandData[0].video_url != ''" width="640" height="352" frameborder="0" webkitallowfullscreen
                                mozallowfullscreen allowfullscreen></iframe>
                        </div>
                    </div>
                </div>
                <div class="home-cta grid-100 grid-parent layer1">
                    <a href="https://vimeo.com/rossnoble" class="layer1" target="_blank">
                        <span>GO TO VIMEO</span>
                        <img src="../../assets/images/arrow_home_cta.png"/>
                    </a>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { apiRequest } from "../../services";
export default {
     data() {
        return {
           OnDemandData: [] 
        };
    },
    mounted() {
        apiRequest("on-demand-video").then(this.receivedData);
    },
    methods: {
        receivedData(data) {
            this.OnDemandData = data.reverse();
        },
    },
}
</script>



// WEBPACK FOOTER //
// OnDemand.vue?602f187e